import React from "react"
import { styled } from "themes"
import { Input } from "antd"

export const StyledTextArea = styled((props: any) => (
  <Input.TextArea {...props} />
))``
